enum DataLayerClickTarget {
  SHOW_MORE_RESULTS = 'show-more-results',
  CLICK_RESULT = 'click-result',
  DID_YOU_MEAN_SUGGESTION = 'did-you-mean-suggestion',
  CONTEXT_RESULTS= 'context-result',
  ALL_RESULTS = 'all_results',
  SWAP_LAYOUT = 'swap-layout',
  FILTER = 'filter',
  NONE = 'none',
}

export default DataLayerClickTarget;
